module.exports = __webpack_public_path__ + "static/media/N5.7a3b9fd4.png";